<script setup>
import ErrorPanel from 'components/ErrorPanel.vue';
import { usePageMeta } from 'composables/page-meta';
import AppRoute from 'src/router/app-route';
import { Route } from 'src/router/routes';
import { buildPageMeta } from 'src/utils/page-meta-util';

usePageMeta(buildPageMeta({
    title: 'Page Not Found',
    description: 'This page could not be found. Explore Australian tech market insights on Xprt Dev.',
    robots: 'noindex,nofollow'
}));
</script>

<template>
    <ErrorPanel :status-code="404" class="page-not-found-error-page" reason="Page not found" title="There's nothing at this address.">
        The link may be out of date, or the address mistyped. Check it, or carry on from the market overview.
        <template #actions>
            <q-btn :to="AppRoute.build(Route.MarketOverview)" color="primary" label="Open the market overview" no-caps unelevated/>
            <q-btn :to="AppRoute.build(Route.Home)" color="primary" label="Go to the home page" no-caps outline/>
        </template>
    </ErrorPanel>
</template>
